import { render, staticRenderFns } from "./AbstractTermsAndConditionsPage.vue?vue&type=template&id=5bfdd440"
import script from "./AbstractTermsAndConditionsPage.vue?vue&type=script&lang=js"
export * from "./AbstractTermsAndConditionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports